module.exports = __webpack_public_path__ + "home_back2.6963802ce58561f85bcc.png";


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/assets/images/home_back2.png
// module id = ../../../../../src/assets/images/home_back2.png
// module chunks = 1